export default __webpack_public_path__ + "static/media/slave.925c6840.jpg";